import { PortalConfigurations } from '@Ravnur-Inc/shared/types/Configurations';
import { Permissions } from './Permissions';
import { PortalSettings } from './Settings';
import { LocaleEntity } from './Translation';
import { User$Details } from './User';
import { ApplicationTypes } from '@Ravnur-Inc/shared/types/Application';

export enum PortalPageType {
  PUBLIC = 'public',
  PORTAL = 'portal',
}

export interface RavnurApplication {
  id: string;
  portalUrl: string;
  adminUrl: Nullable<string>;
  isRoot: boolean;
  applicationType: ApplicationTypes;
  userPermissions: Permissions;
  startPage: Nullable<string>;

  name: string;
  logoUrl: string;
}

export type AuthResponse = {
  user: User$Details;
  applications: RavnurApplication[];
  userPermissions: Permissions;
  portalFeatures: PortalSettings;
  authToken: string;
  publicDomain: string;
  cookieName: string;

  portalConfiguration: PortalConfigurations;

  supportedLocales: LocaleEntity[];
  translationHash: string;
};
